<template>
  <div>
    <Card>
      <template #content>
        <div class="d-flex flex-column align-items-center w-100">
          <div v-if="!applications">
            <i class="fas fa-spinner fa-spin"></i>
          </div>
          <div v-else-if="applications.length" class="w-100">
            <FormatTable
              :formats="applications"
              @select-format="gotoShow"
              class="w-100"
            />
          </div>
          <div v-else class="d-flex align-items-center">
            <span>申請書が存在しません</span>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useFormats } from "/@/vue/composables";
import { Label as FormLabel } from "/@/vue/components/Atom";
import { List as FormatsList } from "/@/vue/components/Molecules/Format";
import { Table as FormatTable } from "/@/vue/components/Organisms/Users/Formats";
import Card from "primevue/card";

const { getFormats } = useFormats();
const { data: formats } = getFormats({
  types: ["application"],
});

const allFormats = computed(() => {
  if (!formats.value) return [];

  return formats.value;
});

const bylaws = computed(() => {
  if (!formats.value) return [];

  return allFormats.value.filter((format) => format.formatType === "bylaws");
});

const applications = computed(() => {
  if (!formats.value) return [];

  return allFormats.value.filter(
    (format) => format.formatType === "application"
  );
});

function gotoShow(id: number) {
  const target = applications.value.find((app) => app.id === id);
  const pdfUrl = target?.attachedPdfs[0].url;
  window.open(pdfUrl, "_blank");
}
</script>

<style scoped></style>
